import * as React from "react";
const SvgFiRrTeamCheck = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-team-check_svg__a)">
      <path
        fill="#062147"
        d="M5.5 11C7.43 11 9 9.43 9 7.5S7.43 4 5.5 4 2 5.57 2 7.5 3.57 11 5.5 11m0-5C6.327 6 7 6.673 7 7.5S6.327 9 5.5 9 4 8.327 4 7.5 4.673 6 5.5 6m3.331 8.314a1 1 0 0 1-1.388.274 3.47 3.47 0 0 0-1.943-.589 3.494 3.494 0 0 0-3.479 3.11 1.001 1.001 0 0 1-1.988-.22 5.493 5.493 0 0 1 5.467-4.89c1.094 0 2.15.32 3.057.927a1 1 0 0 1 .274 1.388M15.501 7C17.43 7 19 5.43 19 3.5S17.43 0 15.5 0 12 1.57 12 3.5 13.57 7 15.5 7m0-5c.826 0 1.5.673 1.5 1.5S16.326 5 15.5 5c-.828 0-1.5-.673-1.5-1.5S14.672 2 15.5 2m1.5 8c-3.86 0-7 3.141-7 7s3.14 7 7 7c3.858 0 7-3.141 7-7s-3.142-7-7-7m0 12c-2.758 0-5-2.243-5-5s2.242-5 5-5c2.756 0 5 2.243 5 5s-2.244 5-5 5m3.221-6.212a1 1 0 0 1-.029 1.414l-2.213 2.124a2.35 2.35 0 0 1-1.653.671 2.38 2.38 0 0 1-1.663-.674l-1.132-1.109a1 1 0 1 1 1.4-1.428l1.131 1.108a.374.374 0 0 0 .522-.002l2.223-2.134a1 1 0 0 1 1.414.029z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-team-check_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrTeamCheck;
